var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#2A3042"}},[_c('main',[_c('div',{staticClass:"container-fluid main-content"},[_vm._t("default")],2)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }